import { useState } from 'react';
import { Button, Layout, Row, Typography } from 'antd';
import { Link } from 'react-router';

import { MenuUnfoldOutlined } from '@ant-design/icons';

import { LOGO, SMALL_LOGO } from '../../constants';
import { UserRole } from '../../enum';
import { useAppSelector } from '../../hooks';
import { useCapturePostHog } from '../../hooks/useCapturePostHog';
import { redirectPage } from '../../routes/routes';
import type { AuthResult, CurrentUser } from '../pages/Login/authSlice';
import { SideNavMenu } from './sidemenu';

const getText = (currentUser: CurrentUser, authResult: AuthResult) => {
  if (currentUser.role === UserRole.ADMIN) {
    return `Admin (${currentUser.region})`;
  } else {
    return authResult.org_name;
  }
};

export const SideNav = () => {
  const authResult = useAppSelector((state) => state.authSlice.authResult);
  const currentUser = useAppSelector((state) => state.authSlice.currentUser);
  const [collapsed, setCollapsed] = useState(true);
  const { capturePostHogCustomEvent } = useCapturePostHog();
  const logo = collapsed ? SMALL_LOGO : LOGO;

  const handleToggle = () => {
    const newCollapsedState = !collapsed;
    setCollapsed(newCollapsedState);
    capturePostHogCustomEvent(`Sidebar ${newCollapsedState ? 'collapsed' : 'expanded'}`);
  };

  return (
    <Layout.Sider width={250} className="sideBar" trigger={null} collapsed={collapsed} theme="light" collapsible>
      <Row align="middle" justify="start" wrap={false} style={{ height: 60, paddingRight: 8 }}>
        <Button className="sideMenuBtn" aria-label="Toggle sidebar" aria-expanded={!collapsed} onClick={handleToggle}>
          <MenuUnfoldOutlined />
        </Button>
        {!collapsed && (
          <Typography.Text className="side-bar-text side-bar-text-animated" strong>
            {getText(currentUser, authResult)}
          </Typography.Text>
        )}
      </Row>
      <Row align="middle" justify="center" style={{ marginTop: 8 }}>
        <Link to={redirectPage(currentUser)}>
          <img src={logo.src} alt={logo.alt} style={{ display: 'block', margin: 'auto', height: logo.sidebarHeight }} />
        </Link>
      </Row>
      <SideNavMenu />
    </Layout.Sider>
  );
};
